import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import { bool, func, object } from 'prop-types'
import axios from 'axios'
import { getAuthToken } from '../../utils/sessionStorage'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import moment from 'moment'
import { SubmissionError } from 'redux-form'

// actions
import { updateVideo } from '../../actions'

// utils
import config from '../../config'

// forms
import VideoConfigForm from '../forms/VideoConfigForm'

class VideoConfigModal extends Component {
  constructor () {
    super()

    this.state = {
      loading: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleSubmit (formValues) {
    if (formValues.has_no_personalized_fields) {
      formValues.personalized_fields = {}
    } else {
      formValues.personalized_fields = formValues.personalized_fields || {}
    }
    if (formValues.product === undefined) {
      throw new SubmissionError({ _error: 'Selecione um produto.' })
    }
    if ((formValues.segment === undefined) || (formValues.segment.personalite === false && formValues.segment.uniclass === false && formValues.segment.varejo === false)) {
      throw new SubmissionError({ _error: 'Ao menos um segmento deve ser marcado.' })
    }
    this.setState({ loading: true })
    const { video, updateVideo } = this.props
    let url = `${config.url}/campaigns/${video.campaign_id}/videos/${video.id}/video_config`
    let videoConfig = {
      title: formValues.title,
      id_menu: formValues.id_menu,
      text: formValues.text,
      start_date: formValues.start_date,
      end_date: formValues.end_date,
      has_no_personalized_fields: formValues.has_no_personalized_fields || false,
      product: formValues.product,
      personalized_fields: {
        user_name: formValues.personalized_fields.user_name || false,
        min_value: formValues.personalized_fields.min_value || false,
        max_value: formValues.personalized_fields.max_value || false,
        original_proposal_value: formValues.personalized_fields.original_proposal_value || false,
        original_split_value: formValues.personalized_fields.original_split_value || false,
        original_splits: formValues.personalized_fields.original_splits || false,
        new_proposal_value: formValues.personalized_fields.new_proposal_value || false,
        new_split_value: formValues.personalized_fields.new_split_value || false,
        new_splits: formValues.personalized_fields.new_splits || false,
        proposal_value: formValues.personalized_fields.proposal_value || false,
        split_value: formValues.personalized_fields.split_value || false,
        proposal_splits: formValues.personalized_fields.proposal_splits || false,
        reserva: formValues.personalized_fields.reserva || false,
        investment_profile: formValues.personalized_fields.investment_profile || false
      },
      segment: {
        varejo: formValues.segment.varejo || false,
        uniclass: formValues.segment.uniclass || false,
        personalite: formValues.segment.personalite || false
      }
    }
    axios({
      method: 'POST',
      url: url,
      headers: {'X-User-Token': getAuthToken()},
      data: {
        video_config: videoConfig
      }
    })
      .then((res) => {
        this.setState({ loading: false })
        let updatedVideo = res.data
        updateVideo(video.campaign_id, updatedVideo)
        toastr.success('Configurações salvas com sucesso!')
        this.props.close()
      })
      .catch((e) => {
        this.setState({ loading: false })
        toastr.error('Ocorreu um erro. Tente novamente.')
      })
  }
  render () {
    const { show, close, video } = this.props
    let { loading } = this.state
    let videoConfig
    if (video.config !== undefined) {
      videoConfig = {
        ...video.config,
        start_date: moment(video.config.start_date).format('DD/MM/YYYY'),
        end_date: moment(video.config.end_date).format('DD/MM/YYYY')
      }
    }
    return (
      <Modal show={show} onHide={close} className='modal--big'>
        <Modal.Header closeButton>
          <Modal.Title>Configuração de video</Modal.Title>
        </Modal.Header>
        <Modal.Body className='clearfix'>
          <VideoConfigForm onSubmit={this.handleSubmit} initialValues={videoConfig} loading={loading} />
        </Modal.Body>
      </Modal>
    )
  }
}

VideoConfigModal.propTypes = {
  show: bool,
  close: func,
  video: object,
  updateVideo: func
}

const mapDispatchToProps = (dispatch) => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video))
  }
})

export default connect(null, mapDispatchToProps)(VideoConfigModal)



// WEBPACK FOOTER //
// ./src/components/modals/VideoConfigModal.js